import * as React from 'react';
import {Svg, Path} from 'react-native-svg';

const VerticalDotsIcon = ({tintColor = '#001533', ...props}) => {
  return (
    <Svg
      width={4}
      height={16}
      viewBox="0 0 4 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <Path
        d="M2 1.25a.75.75 0 110 1.5.75.75 0 010-1.5zm0 6a.75.75 0 110 1.5.75.75 0 010-1.5zm0 6a.75.75 0 110 1.5.75.75 0 010-1.5z"
        fill={tintColor}
        stroke={tintColor}
        strokeWidth={1.5}
      />
    </Svg>
  );
};

export default VerticalDotsIcon;
